import React, { useState } from 'react';
import MembNrmlLoginApi from 'Apis/MembNrmlLoginApi';
import { Helmet } from 'react-helmet-async';
import { useNavigate , Link} from "react-router-dom";
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import SsoLoginUi from './SsoLoginUi';
import CbtMembJoinLink from './CbtMembJoinLink';
import MembJoinFormMdalUi from 'Views/MembJoin/MembJoinFormMdalUi';
import useRecaptcha from 'Utils/useRecaptcha';
import IsLoginApi from 'Apis/IsLoginApi';
import { useDispatch } from 'react-redux';
import { LoginInfoStateChng } from 'Stores/LoginInfoReducer';
import { validateInput } from 'Utils/XssFilter';
import { useAsyncAction } from 'hooks/useAsyncAction';
import 'Assets/css/LoginModal.css';

type Props = {
    open: boolean;
    onClose: () => void;
    referrer?: string | null;
};

const LoginModal: React.FC<Props> = ({ open, onClose, referrer: propReferrer }) => {
    const navigate = useNavigate();
    const [loginId,setLoginId] = useState("");
    const [passwd,setPasswd] = useState("");
    const [loginAlertTxt,setloginAlertTxt] = useState("");
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const LoginIdHandler = (event:any) => {
        const filteredValue = validateInput(event.currentTarget.value, 'loginId', false);
        setLoginId(filteredValue);
        setloginAlertTxt("");
    }
    const PasswdHandler = (event:any) => {
        const filteredValue = validateInput(event.currentTarget.value, 'password', false);
        setPasswd(filteredValue);
        setloginAlertTxt("");
    }
    const membJoinLinkTxt = [langData&&langData.LOGIN_FIND_LOGIN_ID_BTN_00,langData&&langData.LOGIN_FIND_PASSWD_MAIN_BTN_00,langData&&langData.LOGIN_MEMB_JOIN_MAIN_BTN_00];
    const { getToken } = useRecaptcha();
    const dispatch = useDispatch();

    const [modalView, setModalView] = useState<'login'|'MembJoin'|'MembFindId'|'MembFindPw'>('login');

    const closeAndRefresh = async () => {
        try {
            const resp = await IsLoginApi();
            if (resp) {
                try { dispatch(LoginInfoStateChng(resp)); } catch (e) { console.error('dispatch LoginInfoStateChng failed', e); }
            }
        } catch (e) {
            console.error('IsLoginApi failed during refresh', e);
        }
        try { onClose(); } catch (e) { console.error('onClose threw', e); }
    };

    const performLogin = async () => {
        let token = '';
        try {
            token = await getToken('login');
        } catch (err) {
            setloginAlertTxt(langData && langData.COMM_CPTCH_ERROR_DESC_00 || 'reCAPTCHA 실행 실패. 잠시 후 다시 시도해주세요.');
            return;
        }
        const ref = propReferrer || null;
        const Resp = await MembNrmlLoginApi(loginId, passwd, token);

        switch(Resp.apiHdr.code) {
            case "ATHN0000": {
                if(Resp.apiBody?.idntMthdCd == "NA") {
                    await closeAndRefresh();
                    navigate("/Mypage", { replace: true });
                } else {
                    await closeAndRefresh();
                }
            }
            break;
            case"ATHN2002":
                setloginAlertTxt(langData&&langData.COMM_MAIN_RSLT_DESC_00);
            break;
            default:
                setloginAlertTxt(`${Resp.apiHdr.msg}`);
            break;
        }
    };

    const executeLogin = useAsyncAction(performLogin);

    const MembLoginFunc = (e:any) => {
        e.preventDefault();
        if(!loginId) {
            setloginAlertTxt(langData&&langData.LOGIN_MAIN_LOGIN_INPUT_DESC_00);
        }else if(!passwd){
            setloginAlertTxt(langData&&langData.LOGIN_PAGE_PASSWD_INPUT_DESC_00)
        }else {
            executeLogin();
        }
    }

    if (!open) return null;

    return (
        <div className="modalOverlay" onClick={onClose}>
            <div className="modalContent cbtLoginModal" onClick={(e) => e.stopPropagation()}>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}`}</title>
                </Helmet>
                <div className='loginModalContainer'>
                    <div className='membIconWrap'>
                        <h1>{langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}</h1>
                    </div>
                    {modalView === 'login' ? (
                    <>
                    <form action="" onSubmit={MembLoginFunc}>
                        <ul className='loginInputUl'>
                            <li>
                                <input placeholder={`${langData&&langData.LOGIN_MAIN_LOGIN_ID_LBL_00}`} className='idInput' onChange={LoginIdHandler}></input>
                            </li>
                            <li>
                                <input placeholder={`${langData&&langData.LOGIN_MAIN_PASSWD_MAIN_LBL_00}`} type='password' className='passwdInput' autoComplete="off" onChange={PasswdHandler}></input>
                            </li>
                            <p className='loginAlertTxt'>{loginAlertTxt}</p>
                        </ul>
                        <button className='loginBtn' type='submit'>{langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}</button>
                    </form>
                    <SsoLoginUi referrer={propReferrer || null} viewType={"modal"} onClose={closeAndRefresh} />
                    <CbtMembJoinLink referrer={propReferrer || null} membJoinLinkTxt={membJoinLinkTxt} inModal={true} onChangeView={setModalView} />
                    </>
                    ) : null}

                    {modalView === 'MembJoin' ? (
                        <div className="modalInnerView">
                            
                            <MembJoinFormMdalUi />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default LoginModal;
